// @flow
import { HOME_PAGE_SLUGS } from 'utils/constants';
import { pathWithParams } from 'utils/url';

type ListingSearchType = ListingType | 'BLOG' | 'CMS_PAGE';

export const listingSearchHome = (l: ?ListingSearchType) => {
  switch (l) {
    case 'GRAD_PROGRAM':
      return USER_LOCALE === 'en'
        ? '/grad-schools'
        : `/${USER_LOCALE}/grad-schools`;
    case 'IDEALIST_DAY_EVENT':
      return `/${USER_LOCALE}/days/home`;
    case 'VOLOP':
    case 'JOB':
    case 'INTERNSHIP':
    case 'ORG':
    case 'GROUP':
    case 'BLOG':
    case 'ALL':
      return `/${USER_LOCALE}/${HOME_PAGE_SLUGS[l][USER_LOCALE]}`;
    case 'CMS_PAGE':
    default:
      return null;
  }
};

export const getHomeUrl = (
  l: DefaultSearchType,
  queryParams: { [string]: string } = {}
) => {
  const h = listingSearchHome(l);
  return h
    ? pathWithParams(h, queryParams)
    : pathWithParams(`/${USER_LOCALE}`, { ...queryParams });
};

// Effectively the string version of `listingSearchHome`. Flow complains on null string coercion
// Returns '' if no special listing search home (e.g., uses the home page path)
export const listingSearchHomePath = (l: ListingSearchType) =>
  listingSearchHome(l) || '';
